import { Component, computed, input } from '@angular/core';
import { IProgramSummary, LessonTypeCount } from '../../api/mylb/interfaces/iprogram-summary.interface';
import { MDProgressBarComponent, MDTagComponent } from '@melodic-ui/components';

/** The fields a row needs, so callers without a full program summary (the enrollment tasks lessons check) can draw the same bars. */
export type LessonTypeProgress = Pick<LessonTypeCount, 'lessonTypeName' | 'completedLessons' | 'totalLessons' | 'expectedLessons'>;

@Component({
	selector: 'lb-program-completion-summary',
	standalone: true,
	imports: [MDTagComponent, MDProgressBarComponent],
	templateUrl: './program-completion-summary.component.html',
	styleUrl: './program-completion-summary.component.scss'
})
export class ProgramCompletionSummaryComponent {
	program = input<IProgramSummary>();
	/** Takes precedence over `program` when both are set. */
	lessonCounts = input<LessonTypeProgress[]>();

	rows = computed<LessonTypeProgress[]>(() => this.lessonCounts() ?? this.program()?.lessonCounts ?? []);
}
